// WhyUs.js
import React from 'react';
import './WhyUsSection.css';

const WhyUs = ({ isDarkMode }) => {
  return (
    <section className={`why-us ${isDarkMode ? 'dark' : 'light'}`}>
      <div className="overlay">
        <div className="why-us-content">
          <h2>Why Choose Us?</h2>
          <p>
          At AstraSight, we blend innovation, expertise, and dedication to deliver top-tier web design, marketing, software development, and cybersecurity solutions. We don’t just build websites—we build brands. With a focus on quality, efficiency, and long-term success, we ensure your business stands out in the digital
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
